/* eslint-disable eqeqeq,no-param-reassign,@typescript-eslint/no-throw-literal,@typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../app/constants/events';

xplenty
  .directive('bgSplitter', [
    '$rootScope',
    function ($rootScope) {
      return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
          orientation: '@',
        },
        template: '<div class="split-panes {{orientation}}" ng-transclude></div>',
        controller: [
          '$scope',
          function ($scope) {
            $scope.panes = [];

            this.addPane = function (pane) {
              if ($scope.panes.length > 1) throw 'splitters can only have two panes';
              $scope.panes.push(pane);
              return $scope.panes.length;
            };
          },
        ],
        link(scope, element, attrs) {
          const handler = angular.element('<div class="split-handler"></div>');
          const pane1 = scope.panes[0];
          const pane2 = scope.panes[1];
          const vertical = scope.orientation == 'vertical';
          const pane1Min = pane1.minSize || 0;
          const pane2Min = pane2.minSize || 0;
          let drag = false;

          pane1.elem.after(handler);

          element.bind('mousemove', function (ev) {
            if (!drag) return;

            const bounds = element[0].getBoundingClientRect();
            let pos = 0;

            if (vertical) {
              const height = bounds.bottom - bounds.top;
              pos = ev.clientY - bounds.top;

              if (pos < pane1Min) return;
              if (height - pos < pane2Min) return;

              handler.css('top', `${pos}px`);
              pane1.elem.css('height', `${pos}px`);
              pane2.elem.css('top', `${pos}px`);
            } else {
              const width = bounds.right - bounds.left;
              pos = ev.clientX - bounds.left;

              if (pos < pane1Min) return;
              if (width - pos < pane2Min) return;

              handler.css('left', `${pos}px`);
              pane1.elem.css('width', `${pos}px`);
              pane2.elem.css('left', `${pos}px`);
            }
          });

          handler.bind('mousedown', function (ev) {
            ev.preventDefault();
            drag = true;
            $rootScope.$broadcast(EVENTS.SPLITTER_RESIZE_STARTED);
          });

          angular.element(document).bind('mouseup', function (ev) {
            drag = false;
            $rootScope.$broadcast(EVENTS.SPLITTER_RESIZE_COMPLETED);
          });
        },
      };
    },
  ])
  .directive('bgPane', function () {
    return {
      restrict: 'E',
      require: '^bgSplitter',
      replace: true,
      transclude: true,
      scope: {
        minSize: '=',
      },
      template: '<div class="split-pane{{index}}" ng-transclude></div>',
      link(scope, element, attrs, bgSplitterCtrl) {
        scope.elem = element;
        scope.index = bgSplitterCtrl.addPane(scope);
      },
    };
  });
